module.exports = __webpack_public_path__ + "media/images/ic_panier_repas-84b1c1bf9651c12c79bc2f614a056b84.svg";